import type { GameStatus, Stars } from '../types';
import { STAR_THRESHOLDS } from './constants';

/**
 * Сколько бомба «услышала» подсказку: нагрев от уверенности Jev p (0..1) в том, что подсказка указывает на бомбу.
 * Греет КАЖДЫЙ ход, даже если ИИ открыл верное слово. Jev даёт «фон» 5–15 % даже несвязанным словам —
 * отрезаем его и усиливаем сильные связи: 0.2 → 4 %, 0.3 → 10 %, 0.5 → 30 %, 0.7 → 54 %, 0.9 → 84 %.
 * Любое изменение формулы требует перепроверки звёздных порогов и критериев генератора.
 */
export const heatOf = (p: number): number => (Math.max(0, p - 0.1) / 0.9) ** 1.5;

/** Ниже этого нагрев от бомбы игроку не показываем: «+0%» только сбивает с толку. */
export const HEARD_VISIBLE = 0.005;

/**
 * Звёзды по итоговой шкале бомбы. Шкала растёт от двух причин: бомба «услышала» подсказку (`heatOf`, каждый ход)
 * и открытая ИИ обманка (+DECOY_HEAT). До 25 % — ★★★, до 50 % — ★★, иначе ★.
 * Если менять DECOY_HEAT или пороги — обнови тексты обучения (i18n/ru.ts → help.stars).
 */
export function starsFor(status: GameStatus, heat: number): Stars {
  if (status !== 'win') return 0;
  if (heat <= STAR_THRESHOLDS.three) return 3;
  if (heat <= STAR_THRESHOLDS.two) return 2;
  return 1;
}
